import React, { useState } from "react";

import "./stylesPersonalInfo.css";

import EditIcon from "../../../assets/icons/ic_edit.svg";
import BronzeIcon from "../../../assets/icons/ic_bronze-status.svg";
import VerifiedIcon from "../../../assets/icons/ic_verified.svg";
import AvatarIcon from "../../../assets/icons/avatar.png";
import { CloseOutlined } from "@ant-design/icons";

import AddNoteModal from "./AddNoteModal/AddNoteModal";

import { Modal } from "antd";
import dayjs from "dayjs";

import EditNoteModal from "./EditNoteModal/EditNoteModal";

function PersonalInfo() {
  const [isAddNoteModalOpen, setIsAddNoteModalOpen] = useState(false);
  const [isEditNoteModalOpen, setIsEditNoteModalOpen] = useState(false);
  const [notes, setNotes] = useState([]);
  const [editNote, setEditNote] = useState(null);

  const handleAddNoteModalOk = () => {
    setIsAddNoteModalOpen(false);
  };

  const handleAddNoteModalCancel = () => {
    setIsAddNoteModalOpen(false);
  };

  const showAddNoteModal = () => {
    setIsAddNoteModalOpen(true);
  };

  const showEditNoteModal = (note) => {
    console.log("note", note);
    setIsEditNoteModalOpen(true);
    setEditNote(note);
  };

  const handleEditNoteModalOk = () => {
    setIsEditNoteModalOpen(false);
  };

  const handleEditNoteModalCancel = () => {
    setIsEditNoteModalOpen(false);
  };

  const handleNotesChange = (note, edit = false) => {
    if (edit) {
      const updatedNotes = notes.map((prevnote) =>
        prevnote.id === editNote.id
          ? { ...prevnote, note: note.note }
          : prevnote
      );
      setNotes(updatedNotes);
      return;
    }

    const name = "PAM Admin";
    const time = dayjs().format("MMM DD, YYYY hh:mm A");
    const id = notes.length + 1;

    setNotes((prevNotes) => [...prevNotes, { id, name, time, note }]);
  };

  const handleDeleteNote = (id) => {
    setNotes((prevNotes) => prevNotes.filter((note) => note.id !== id));
  };

  return (
    <div className="personal-info-container">
      <Modal
        closable={false}
        open={isAddNoteModalOpen}
        onOk={handleAddNoteModalOk}
        onCancel={handleAddNoteModalCancel}
        footer={null}
        width={400}
      >
        <AddNoteModal
          handleCancel={handleAddNoteModalCancel}
          handleNotesChange={handleNotesChange}
        />
      </Modal>
      <Modal
        closable={false}
        open={isEditNoteModalOpen}
        onOk={handleEditNoteModalOk}
        onCancel={handleEditNoteModalCancel}
        footer={null}
        width={400}
      >
        <EditNoteModal
          handleCancel={handleEditNoteModalCancel}
          handleNotesChange={handleNotesChange}
          editNote={editNote}
        />
      </Modal>
      <div className="personal-info-header">
        <h2>Personal info</h2>
        <img src={EditIcon} alt="edit icon" />
      </div>
      <div className="personal-info-body">
        <div className="personal-info-row">
          <div className="personal-info">
            <p className="first">User ID</p>
            <p className="second">00000001</p>
          </div>
          <div className="personal-info">
            <p className="first">User name</p>
            <p className="second">LuckyPlayer</p>
          </div>
        </div>
        <div className="personal-info-row">
          <div className="personal-info">
            <p className="first">First Name</p>
            <p className="second">Jane</p>
          </div>
          <div className="personal-info">
            <p className="first">Last Name</p>
            <p className="second">Cooper</p>
          </div>
        </div>
        <div className="personal-info-row">
          <div className="personal-info">
            <p className="first">Email</p>
            <p className="second">lucky@example.com</p>
          </div>
          <div className="personal-info">
            <p className="first">Phone</p>
            <p className="second">+1 (202) 555-0143</p>
          </div>
        </div>
        <div className="personal-info-row">
          <div className="personal-info">
            <p className="first">Date of registration</p>
            <p className="second">
              Oct 05, 2024
              <span className="number-of-days">13 days</span>
            </p>
          </div>
          <div className="personal-info">
            <p className="first">Rank</p>
            <p className="badge-bettor">
              <img src={BronzeIcon} alt="bronze icon" />
              BRONZE BETTOR
            </p>
          </div>
        </div>
        <div className="personal-info-row">
          <div className="personal-info">
            <p className="first">Address</p>
            <p className="second w-200">
              75 Higuera St # 201 San Luis Obispo, CA 93401 USA
            </p>
          </div>
          <div className="personal-info">
            <p className="first">KYC</p>
            <p className="second">
              <img src={VerifiedIcon} alt="verified icon" />
              Verified
              <span className="number-of-days">Oct 05, 2024</span>
            </p>
          </div>
        </div>
      </div>
      <div className="personal-info-footer">
        <div className="notes-header">
          <h2>Notes</h2>
          <button onClick={showAddNoteModal}>Add Note</button>
        </div>
        <div className="notes-container">
          {notes.map((note, index) => (
            <div key={index} className="note">
              <div className="note-header">
                <div className="note-header-left">
                  <img src={AvatarIcon} alt="user icon" />
                  <p className="note-name">{note.name}</p>
                </div>
                <div className="note-header-right">
                  <p className="note-time">{note.time}</p>
                  {/* <img src={DeleteIcon} alt="delete icon" /> */}
                </div>
              </div>
              <div className="note-body">
                <p className="note-text">{note.note}</p>
                <div className="note-actions">
                  <img
                    src={EditIcon}
                    alt="edit icon"
                    className="edit-icon"
                    onClick={() => showEditNoteModal(note)}
                  />
                  <CloseOutlined
                    className="close-icon"
                    onClick={() => handleDeleteNote(note.id)}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PersonalInfo;
